<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import BaseBubble from 'next/message/bubbles/Base.vue';
import MessageMeta from '../MessageMeta.vue';
import { useMessageContext } from '../provider.js';
import { MESSAGE_VARIANTS, ORIENTATION } from '../constants.js';

const { contentAttributes, variant, orientation } = useMessageContext();

const { t } = useI18n();

// Written by Instagram::ReferralService when a customer opens an ig.me link
// into an existing thread, which resets the messaging window. Kept separate
// from the shared `referral` key, which routes to the WhatsApp ad bubble.
const referral = computed(() => contentAttributes.value?.igReferral || {});

const reference = computed(() => referral.value.ref);

const metaAlignClass = computed(() =>
  orientation.value === ORIENTATION.RIGHT ? 'justify-end' : 'justify-start'
);

const metaColorClass = computed(() =>
  variant.value === MESSAGE_VARIANTS.PRIVATE
    ? 'text-n-amber-12/50'
    : 'text-n-slate-11'
);
</script>

<template>
  <BaseBubble hide-meta class="p-0" data-bubble-name="instagram-referral">
    <div class="flex flex-col gap-1.5 px-3 py-2.5">
      <div class="flex items-center gap-2">
        <span class="i-lucide-link-2 size-4 shrink-0 text-n-slate-11" />
        <span class="text-sm text-n-slate-12">
          {{ t('CONVERSATION.INSTAGRAM_REFERRAL.REOPENED') }}
        </span>
      </div>
      <span
        v-if="reference"
        class="px-2 py-0.5 font-mono text-xs rounded self-start bg-n-alpha-2 text-n-slate-11"
      >
        {{ reference }}
      </span>
      <MessageMeta :class="[metaAlignClass, metaColorClass]" />
    </div>
  </BaseBubble>
</template>
